import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-banner-sowhatbuy';

const html = `
<div data-attribute="wrap-card" data-use-banner-mobile="true"
  data-banner-desktop="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dafbb8b315296d0b7469.webp?w=1000"
  class="wrap-card"
  style="--banner-desktop: url('https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dafbb8b315296d0b7469.webp?w=1000')">
  <div class="banner-mobile">
    <img data-attribute="banner-mobile-image"
      src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dbdd2382ec6b3152fab4.webp" alt="">
  </div>
  <div class="container">
    <div class="wrap-content" data-attribute="wrap-content" data-width-content="800px" style="--width-content: 800px;">
      <div data-attribute="title-banner" class="title-banner">
        <h2>LED Rechargeable<br>Square Magnifier</h2>
        <p>Easy on the eyes, even for small text, making reading more comfortable and enjoyable.</p>
      </div>
      <div data-show="true" data-attribute="list-keybenefits" class="list-keybenefits">
        <div data-attribute="item-benefit" class="item-benefit">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dd8c521b520e13b3ac17.png" alt="">
          </div>
          <div data-attribute="text-benefit" class="text-benefit">
            <p>4X HD</p>
            <p>Magnification</p>
          </div>
        </div>
        <div data-attribute="item-benefit" class="item-benefit">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dd8c521b520e13b3ac17.png" alt="">
          </div>
          <div data-attribute="text-benefit" class="text-benefit">
            <p>3 Brightness<br>Settings</p>
          </div>
        </div>
        <div data-attribute="item-benefit" class="item-benefit">
          <div class="icon-benefit">
            <img data-attribute="icon-benefit"
              src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44dd8c521b520e13b3ac17.png" alt="">
          </div>
          <div data-attribute="text-benefit" class="text-benefit">
            <p>10 LED<br>Lights</p>
          </div>
        </div>
      </div>
      <a class="btn-banner" data-bg-button="#c75023" data-color-button="#ffffff" data-show-discount="true" data-show="true" data-attribute="btn-cta-banner" href="" style="--bg-button: #c75023;--color-button: #ffffff;">
        <div class="group-discount">
          <div class="wrap-discount">
            <img src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44e00b33a0a534b9e66352.png" alt="">
            <div class="wra-value-discount">
              <span data-attribute="value-discount" class="value-discount">50</span>
              <span>%</span>
              <span>OFF</span>
            </div>
          </div>
        </div>
        <div data-attribute="text-button" class="text-btn">Buy Now</div>
        <div data-show="true" data-attribute="icon-btn" class="icon-btn" style="">
          <img src="https://cdn.skyfastimg.com/images/2026/07/01/image-6a44e08a0c7782f8d8631e33.png" alt="">
        </div>
      </a>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  textColor: '#ffffff',
  topPadding: false,
  bottomPadding: false,
  backgroundColor: '#180d00',
});
